import { AGWASuiteApiClientBase, ApiResponse } from '../agwasuite-api';
import type { ClientConfigResult } from '../agwa-api-model';

/**
 * API client for the SPA runtime client-config endpoint. Returns browser-exposed configuration
 * (currently the Google Maps browser key + map id) that must not be baked into the bundle so it can
 * rotate without a rebuild.
 */
export class ApiClientConfig extends AGWASuiteApiClientBase {
  constructor(baseUrl?: string) {
    super(baseUrl);
  }

  /**
   * Get the runtime client configuration for the authenticated session.
   */
  async getClientConfig(): Promise<ApiResponse<ClientConfigResult>> {
    return this.request<ClientConfigResult>('GET', '/api/client-config');
  }
}
